module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/onesence-8-513153da0f625b411a5505741d92459a.webp";